import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../static/icons/turn-arrow.svg'
import _imports_1 from '@/static/icons/checkmark_white_icon.svg'
import _imports_2 from '../../../static/icons/info.svg'


const _hoisted_1 = { class: "decoration-technique-variants" }
const _hoisted_2 = { class: "decoration-technique-variants__main" }
const _hoisted_3 = { class: "decoration-technique-variants__title" }
const _hoisted_4 = { class: "decoration-technique-variants__variant-button-container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "decoration-technique-variants__title" }
const _hoisted_8 = { class: "decoration-technique-variants__input-container" }
const _hoisted_9 = { class: "decoration-technique-variants__label" }
const _hoisted_10 = { class: "decoration-technique-variants__input-container" }
const _hoisted_11 = { class: "decoration-technique-variants__label" }
const _hoisted_12 = {
  key: 1,
  class: "decoration-technique-variants--color-title"
}
const _hoisted_13 = {
  key: 2,
  class: "decoration-technique-variants--color-subtitle"
}
const _hoisted_14 = ["for"]
const _hoisted_15 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_16 = {
  key: 0,
  class: "decoration-technique-variants__warning"
}

import { ref, computed, watch, inject, onMounted } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { configuratorStateKey } from '../ProductConfiguratorKeys';


export default /*@__PURE__*/_defineComponent({
  __name: 'DecorationTechniqueVariants',
  props: {
  productVariants: {
    type: Array,
    required: true,
  },
  variants: {
    type: Array,
    required: true,
  },
  selected: {
    type: String,
    default: '',
  },
  colors: {
    type: Object,
  },
  desiredWidth: {
    type: Number,
    default: 0,
  },
  desiredHeight: {
    type: Number,
    default: 0,
  },
},
  emits: ['selected', 'desiredWidthUpdated', 'desiredHeightUpdated'],
  setup(__props, { emit: __emit }) {

const { websiteText } = useWebsiteTexts();
const emit = __emit;
const { configuratorState } = inject(configuratorStateKey);

const props = __props;

const inputColors = ref(props.colors || {});

const desiredWidthModel = ref(props.desiredWidth ? props.desiredWidth.toString() : '');
const desiredWidth = ref(0);

const desiredHeightModel = ref(props.desiredHeight ? props.desiredHeight.toString() : '');
const desiredHeight = ref(0);

const titleDisplayText = computed(() => {
  const v = props.variants[0];
  if (!v?.nrOfColors && !v?.printAreaFromCM2 && !v?.printAreaToCM2) return '';

  return v.printAreaToCM2
    ? websiteText('decoration__variant_title_size').value
    : websiteText('decoration__variant_title_color').value;
});

function variantColorType(v) {
  return v.nrOfColors === 1
    ? websiteText('decoration__variant_color_single',
      { amount: v.nrOfColors }).value
    : websiteText('decoration__variant_color_multiple',
      { amount: v.nrOfColors }).value;
}

const sortedVariants = computed(() => {
  return Array.from(props.variants).sort((a, b) => a.nrOfColors - b.nrOfColors);
});

function variantDisplayTexts(variant) {
  if (!variant) return '';
  return variant.printAreaToCM2
    ? `${variant.printAreaFromCM2} - ${variant.printAreaToCM2}cm²`
    : (variant.nrOfColors 
      ? variantColorType(variant) 
      : variant.name);
}

const selectedVariant = ref([...props.variants]
  .find(v => v.systemId === props.selected) || {});

const numberOfColorVariants = computed(() => {
  return (!selectedVariant.value.printAreaToCM2 && selectedVariant.value.nrOfColors) || 0;
});

const limitedColorsSelected = computed(() => {
  let colors = {};

  if (numberOfColorVariants.value && (Object.keys(inputColors.value).length > numberOfColorVariants.value)) {
    for (let index = 1; index <= numberOfColorVariants.value; index++) {
      colors[`color${index}`] = inputColors.value[`color${index}`];
    }
  } else {
    colors = inputColors.value;
  }

  return colors;
});

function selectVariant(variant: object) {
  selectedVariant.value = variant;
  emit('selected', variant.systemId, limitedColorsSelected.value);
}

const hasSizeBasedVariants = computed(() => {
  return props.variants.filter(v => v.printAreaToCM2).length != 0;
});

function saveColorInput(val, index: string) {
  inputColors.value[`color${index}`] = val;
  emit('selected', selectedVariant.value.systemId, limitedColorsSelected.value);
}

function selectVariantBasedOnArea() {
  desiredWidth.value = parseInt(desiredWidthModel.value, 10);
  if (Number.isNaN(desiredWidth.value)) {
    return;
  }

  desiredHeight.value = parseInt(desiredHeightModel.value, 10);
  if (Number.isNaN(desiredHeight.value)) {
    return;
  }

  const areaInCm2 = (desiredWidth.value * desiredHeight.value) / 100;

  const matchingVariants = props.variants.filter(v => v.printAreaFromCM2 <= areaInCm2 && v.printAreaToCM2 >= areaInCm2);
  if (matchingVariants.length !== 0) {
    selectVariant(matchingVariants[0]);
  }
  else {
    const largestVariants = props.variants
            .filter(v => v.printAreaFromCM2 <= areaInCm2)
            .sort((a, b) => (a.printAreaFromCM2 < b.printAreaFromCM2) ? 1 : -1);
    if (largestVariants.length !== 0) {
      selectVariant(largestVariants[0]);
    }
  }
}

function validateWidth() {
  if(desiredWidthModel.value) {
    desiredWidthModel.value = desiredWidthModel.value.replace(/\D/g, '');
  }
}

function validateHeight() {
  if(desiredHeightModel.value) {
    desiredHeightModel.value = desiredHeightModel.value.replace(/\D/g, '');
  }
}

watch(desiredWidthModel, () => selectVariantBasedOnArea());
watch(desiredHeightModel, () => selectVariantBasedOnArea());

watch(desiredWidth, () => emit('desiredWidthUpdated', desiredWidth.value));
watch(desiredHeight, () => emit('desiredHeightUpdated', desiredHeight.value));

const notAvailableText = computed(() => {
  if (!selectedVariant.value) {
    return '';
  }

  const selectedTechniqueVariant = sortedVariants.value.find(v=>v.systemId == selectedVariant.value.systemId);
  let notAvailableVariants = [];

  for (var i=0; i < props.productVariants.length; i++) {
    const prodVariant = props.productVariants[i];
    if (selectedTechniqueVariant.supportedVariants.filter(v=> v == prodVariant.systemId).length == 0) {
      notAvailableVariants.push(prodVariant.fields?.Color?.[0]?.name || '');
    }
  }

  if (notAvailableVariants.length == 0) {
    return '';
  }

  const notAvailableVariantsText = notAvailableVariants.join(', ');
  return websiteText('decoration__not_available', {
    decoration: selectedTechniqueVariant.name,
    variant: notAvailableVariantsText
  }).value;

});

onMounted(() => {
  desiredWidthModel.value = props.desiredWidth ? props.desiredWidth.toString() : '';
  desiredHeightModel.value = props.desiredHeight ? props.desiredHeight.toString() : '';
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "decoration-technique-variants__side-gutter" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(titleDisplayText.value), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedVariants.value, (variant) => {
          return (_openBlock(), _createElementBlock("button", {
            class: _normalizeClass(['decoration-technique-variants__variant-button', {
            'decoration-technique-variants__variant-button--selected'
            : variant.systemId === selectedVariant.value.systemId}]),
            key: variant.systemId,
            onClick: ($event: any) => (selectVariant(variant))
          }, [
            _createElementVNode("img", {
              class: _normalizeClass(['decoration-technique-variants__variant-checkmark', {
            'decoration-technique-variants__variant-checkmark--selected'
            : variant.systemId === selectedVariant.value.systemId}]),
              src: _imports_1,
              alt: "white checkmark"
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(variantDisplayTexts(variant)), 1)
          ], 10, _hoisted_5))
        }), 128))
      ]),
      (hasSizeBasedVariants.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(websiteText)('decoration__input_size').value), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(websiteText)('decoration__width').value), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((desiredWidthModel).value = $event)),
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (validateWidth())),
                class: "decoration-technique-variants__input",
                type: "text"
              }, null, 544), [
                [_vModelText, desiredWidthModel.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(websiteText)('decoration__height').value), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((desiredHeightModel).value = $event)),
                onKeyup: _cache[3] || (_cache[3] = ($event: any) => (validateHeight())),
                class: "decoration-technique-variants__input",
                type: "text"
              }, null, 544), [
                [_vModelText, desiredHeightModel.value]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (numberOfColorVariants.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(websiteText)('decoration__variant_color_title').value), 1))
        : _createCommentVNode("", true),
      (numberOfColorVariants.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(websiteText)('decoration__variant_color_subtitle').value), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfColorVariants.value, (number) => {
        return (_openBlock(), _createElementBlock("div", {
          key: number,
          class: "decoration-technique-variants__color-input-container"
        }, [
          _createElementVNode("label", {
            class: "decoration-technique-variants__color-input-text",
            for: `color-input-${number}`
          }, _toDisplayString(_unref(websiteText)('decoration__variant_color').value) + " " + _toDisplayString(number) + ": ", 9, _hoisted_14),
          _withDirectives(_createElementVNode("input", {
            class: "decoration-technique-variants__color-input-field",
            id: `color-input-${number}`,
            type: "text",
            maxlength: "30",
            "onUpdate:modelValue": ($event: any) => ((inputColors.value[`color${number}`]) = $event),
            onChange: ($event: any) => (saveColorInput(inputColors.value[`color${number}`], number))
          }, null, 40, _hoisted_15), [
            [_vModelText, inputColors.value[`color${number}`]]
          ])
        ]))
      }), 128))
    ]),
    (notAvailableText.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            class: "decoration-technique-variants__warning_icon",
            src: _imports_2
          }, null, -1)),
          _createTextVNode(" " + _toDisplayString(notAvailableText.value), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})